import { TableActionVariant } from './Table.constants';
const DEFAULT_SORT_ORDER = 'ascending';
export const tableReducer = (state, action) => {
    switch (action.type) {
        case TableActionVariant.DESELECT: {
            const updatedSelected = state.selected.filter((itemId) => itemId !== action.value);
            return {
                ...state,
                isSelectAll: false,
                selected: updatedSelected,
            };
        }
        case TableActionVariant.DESELECT_ALL: {
            return {
                ...state,
                isSelectAll: false,
                selected: [],
            };
        }
        case TableActionVariant.SELECT: {
            const updatedSelected = state.selected.find((itemId) => itemId === action.value)
                ? state.selected
                : [...state.selected, action.value];
            return {
                ...state,
                selected: updatedSelected,
            };
        }
        case TableActionVariant.SELECT_ALL: {
            return {
                ...state,
                isSelectAll: true,
                selected: action.value,
            };
        }
        case TableActionVariant.SET_SORT: {
            if (state.isMultiSort) {
                let updatedSortConfig;
                const existingColumnSortConfigIndex = state.sortConfig.findIndex((sortConfigItem) => sortConfigItem.columnId === action.value.columnId);
                const existingColumnSortConfig = state.sortConfig[existingColumnSortConfigIndex];
                if (existingColumnSortConfig) {
                    if (existingColumnSortConfig?.sortOrder ===
                        action.value.sortOrder) {
                        updatedSortConfig = state.sortConfig.filter((sortConfigItem) => sortConfigItem.columnId !==
                            action.value.columnId);
                    }
                    else {
                        const newSortConfig = [...state.sortConfig];
                        // Change sort order but not the column sort priority:
                        newSortConfig[existingColumnSortConfigIndex] =
                            action.value;
                        updatedSortConfig = newSortConfig;
                    }
                }
                else {
                    updatedSortConfig = [...state.sortConfig, action.value];
                }
                return {
                    ...state,
                    sortConfig: updatedSortConfig,
                };
            }
            else {
                return {
                    ...state,
                    sortConfig: [action.value],
                };
            }
        }
        case TableActionVariant.TOGGLE_SORT_ORDER: {
            const existingColumnSortConfigIndex = state.sortConfig.findIndex((sortConfigItem) => sortConfigItem.columnId === action.value.columnId);
            const existingColumnSortConfig = state.sortConfig[existingColumnSortConfigIndex];
            if (existingColumnSortConfig) {
                const newSortConfig = [...state.sortConfig];
                newSortConfig.splice(existingColumnSortConfigIndex, 1);
                const newSortOrder = existingColumnSortConfig.sortOrder === 'ascending'
                    ? 'descending'
                    : existingColumnSortConfig.sortOrder === 'descending'
                        ? undefined
                        : 'ascending';
                const modifiedSortConfig = {
                    ...existingColumnSortConfig,
                    sortOrder: newSortOrder,
                };
                return {
                    ...state,
                    sortConfig: [...newSortConfig, modifiedSortConfig],
                };
            }
            if (!state.isMultiSort) {
                const newSortConfig = [
                    {
                        columnId: action.value.columnId,
                        sortOrder: DEFAULT_SORT_ORDER,
                    },
                ];
                return { ...state, sortConfig: newSortConfig };
            }
            const newSortConfig = [
                ...state.sortConfig,
                {
                    columnId: action.value.columnId,
                    sortOrder: DEFAULT_SORT_ORDER,
                },
            ];
            return { ...state, sortConfig: newSortConfig };
        }
        default:
            return state;
    }
};
